<template>
    <div class="post" style="background: white">
        <v-card>
            <v-img v-bind:src="background" aspect-ratio="2.75"></v-img>
            <div class="content">
                <v-card-title primary-title>
                    <div class="display-1 font-weight-bold lighten-2">{{ title }}</div>
                </v-card-title>
                <v-card-text class="post-body">
                    <span v-html="content"></span>
                </v-card-text>
            </div>
        </v-card>
        <!-- <v-card>
            <v-subheader>
                Comments
            </v-subheader>
            <v-card-text class="post-body">
                Comments feature coming soon.
            </v-card-text>
        </v-card> -->
    </div>
</template>

<script>
import db from '@/firebase/firestore'
export default {
    name: 'Post',
    data() {
        return {
            author: null,
            background: '',
            content: null,
            description: null,
            published: null,
            slug: null,
            tags: null,
            title: null,
            type: null,
            items: [
                {
                    text: 'Home',
                    disabled: false,
                    to: 'Home'
                },
                {
                    text: this.title,
                    disabled: true,
                    href: 'breadcrumbs_link_2'
                }
            ]
        }
    },
    created() {
        let ref = db.collection('posts')
        ref.where('slug', '==', this.$route.params.slug).limit(1).get()
        .then((snapshot) => {
            snapshot.forEach( doc => {
                this.author = doc.data().author
                this.background = doc.data().background
                console.log(this.background)
                this.content = doc.data().content
                this.description = doc.data().description
                this.published = doc.data().published
                this.slug = doc.data().slug
                this.tags = doc.data().tags
                this.title = doc.data().title
                this.type = doc.data().type
            })
        })
    },
    methods: {
        
    }
}
</script>

<style>
    .content {
        max-width: 740px;
        margin: 0 auto;
        padding: 50px 20px
    }
    .post-body {
        font-family: 'Playfair Display', 'Roboto Slab', 'Slabo 27px', 'Merriweather', serif;
        font-weight: 400;
        font-style: normal;
        font-size: 21px;
        line-height: 1.58;
        letter-spacing: -.003em;
    }
    p {
        margin-top: 38px;
    }
    p:first-child {
        margin-top: 0;
    }
    pre {
        font-family: Menlo,Monaco,"Courier New",Courier,monospace;
        background-color: #eee !important;
        border-color: #eee !important;
        margin-top: 43px;
        padding: 20px;
        font-size: 16px;
        white-space: inherit;
    }
    p.after {
        margin-top: 8px;
    }
    h3 {
        margin-top: 38px;
        font-family: 'Roboto',sans-serif;
    }
</style>
